import React from 'react';
import { ShieldIcon, ZapIcon, CpuIcon, FileTextIcon, ArrowRightIcon } from 'lucide-react';
export function Gen3Features() {
  const features = [{
    title: 'Gen 3 Gloves',
    description: 'Enhanced sensor placement for precise hand strike detection.',
    icon: <ShieldIcon className="w-8 h-8" data-id="element-84" />,
    linkText: 'Shop Gloves'
  }, {
    title: 'Gen 3 E-Foot Gear',
    description: 'Redesigned for better fit, durability, and scoring accuracy.',
    icon: <ZapIcon className="w-8 h-8" data-id="element-85" />,
    linkText: 'Shop E-Foot'
  }, {
    title: 'Get a Custom Quote',
    description: 'Equipping a team or tournament? Get specialized pricing.',
    icon: <FileTextIcon className="w-8 h-8" data-id="element-86" />,
    linkText: 'Request Quote'
  }];
  return <section className="py-16 bg-white relative -mt-10 z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-87">
      <div className="bg-white rounded-2xl shadow-xl border border-gray-100 p-8 lg:p-12" data-id="element-88">
        <div className="text-center mb-10" data-id="element-89">
          <h2 className="text-3xl font-black text-gray-900 uppercase tracking-tight" data-id="element-90">
            Explore Gen 3
          </h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto mt-4" data-id="element-91"></div>
          <p className="mt-4 text-gray-600 font-medium max-w-2xl mx-auto" data-id="element-92">
            The newest generation of Daedo electronic scoring gear is here.
            Upgrade your equipment for the most accurate scoring experience.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-93">
          {features.map((feature, index) => <a key={index} href="#" className="group flex flex-col items-start p-6 rounded-xl bg-gray-50 hover:bg-blue-50 border border-transparent hover:border-blue-100 transition-all duration-300" data-id="element-94">
              <div className="w-14 h-14 rounded-lg bg-white shadow-sm flex items-center justify-center text-blue-600 mb-5 group-hover:scale-110 group-hover:bg-blue-600 group-hover:text-white transition-all duration-300" data-id="element-95">
                {feature.icon}
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-96">
                {feature.title}
              </h3>
              <p className="text-gray-600 text-sm mb-6 flex-grow" data-id="element-97">
                {feature.description}
              </p>
              <div className="flex items-center text-blue-600 font-bold text-sm uppercase tracking-wider group-hover:text-blue-700" data-id="element-98">
                {feature.linkText}
                <ArrowRightIcon className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-99" />
              </div>
            </a>)}
        </div>
      </div>
    </section>;
}